module.exports = __webpack_public_path__ + "img/35.af2cac0e.jpg";